module.exports = __webpack_public_path__ + "static/quiz_stage_4_bg-38762d858169bf456035d40a9b74d2fd.svg";